import { render, staticRenderFns } from "./PostalrateEditor.vue?vue&type=template&id=5c1a67c2&"
import script from "./PostalrateEditor.vue?vue&type=script&lang=js&"
export * from "./PostalrateEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports